/** Which Naturals portal hosts the engagement UI (nav + HQ-only features). */

export const NATURALS_ENGAGEMENT_PARTNER_BASE = '/naturals/partner/engagement';
export const NATURALS_ENGAGEMENT_WORKSPACE_BASE = '/naturals/workspace/engagement';
export const NATURALS_ENGAGEMENT_DEFAULT_BASE = '/naturals/engagement';
export const NATURALS_PARTNER_OPS_APPOINTMENTS = '/naturals/partner/operations/appointments';
export const NATURALS_PARTNER_GUEST_APPOINTMENTS = '/naturals/partner/guest/appointments';

function isPartnerOpsAppointmentsPath(path) {
  const p = String(path || '');
  return (
    p === NATURALS_PARTNER_OPS_APPOINTMENTS ||
    p.startsWith(`${NATURALS_PARTNER_OPS_APPOINTMENTS}/`) ||
    p === NATURALS_PARTNER_GUEST_APPOINTMENTS ||
    p.startsWith(`${NATURALS_PARTNER_GUEST_APPOINTMENTS}/`)
  );
}

export function getEngagementPortal() {
  if (typeof window === 'undefined') return 'standalone';
  const path = window.location.pathname || '';
  if (isPartnerOpsAppointmentsPath(path)) {
    return 'partner';
  }
  if (path.startsWith(NATURALS_ENGAGEMENT_PARTNER_BASE) || path === `${NATURALS_ENGAGEMENT_PARTNER_BASE}/`) {
    return 'partner';
  }
  if (path.startsWith(NATURALS_ENGAGEMENT_WORKSPACE_BASE) || path === `${NATURALS_ENGAGEMENT_WORKSPACE_BASE}/`) {
    return 'workspace';
  }
  if (path.startsWith('/naturals/workspace/whatsapp')) {
    return 'workspace';
  }
  return 'standalone';
}

/** Workspace HQ or legacy standalone mount — not a franchise partner desk. */
export function isEngagementHqPortal() {
  return getEngagementPortal() !== 'partner';
}

/** HQ-only screens: AI docs, automation settings, message templates. */
export function canManageEngagementHqConfig() {
  return isEngagementHqPortal();
}

/** Instagram DM threads are listed beside WhatsApp on Conversations. */
export const SHOW_INSTAGRAM_CONVERSATIONS_BY_USERNAME = true;
